export function secondsUntil(date) {
    const now = new Date();
    const futureDate = new Date(date);
    const millisecondsDifference = futureDate - now;
    return Math.floor(millisecondsDifference / 1000);
  }